import { Card, Col, Input, Row } from 'antd';
import React, { useEffect, useState } from 'react'
import '../documentRepo.css'
import '../../../styles/seims.css';
import '../../../styles/App.css';
import '../../../styles/index.css';
// import "antd/dist/antd.css";
import "antd/dist/reset.css";

import FilterControl from './FilterControl';

export default function ViewDocument() {

    const mainTitle1 = "Document Repository  - Search";

    const handleInputChange = () => { };
    return (
      <div className="content-container">
        <div className="report-content">
          <Col xs={24}>
            <h1 className="center-align">{mainTitle1}</h1>
          </Col>

          <br></br>
          <div className=".side-by-side">
            <FilterControl handleInputChange={handleInputChange} />
          </div>
        </div>
      </div>
    );
}
